"use client"
import { useEffect, useState } from "react";
import { RiCloseLine } from "react-icons/ri";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { confirmReceptionForAllProducts, getArrivage, updateProductArrivageStatus } from "UpdatedFeatures/api";
import { CiCircleCheck } from "react-icons/ci";
import { toast } from "react-toastify";

const ChangeArrivageStatusModal = ({ open, setOpen, selectedArrivage }) => {
    const [formData, setFormData] = useState(selectedArrivage);
    const [isLoading, setIsLoading] = useState(false);
    const [arrivageStatus, setArrivageStatus] = useState(null);
    const queryClient = useQueryClient();
    console.log(selectedArrivage)
    useEffect(() => {
        if (selectedArrivage) {
            setArrivageStatus(selectedArrivage.status);
            setFormData(selectedArrivage);
        }
    }, [selectedArrivage]);

    const { data } = useQuery({
        queryFn: () => getArrivage(),
        queryKey: ['arrivage']
    });

    const [Arrivage, setArrivage] = useState([]);
    useEffect(() => {
        if (data && data.data) {
            const filteredData = data.data.filter(item => item?.id == selectedArrivage?.id);
            setArrivage(filteredData);
        }
    }, [data, selectedArrivage]);

    const mutation = useMutation({
        mutationFn: updateProductArrivageStatus,
        onSuccess: () => {
            toast.success("Le produit est Réceptionné avec Succès");
            queryClient.invalidateQueries('arrivage');
            setIsLoading(false);
        },
        onError: (error) => {
            console.error("Error updating product arrivage status:", error);
            setIsLoading(false);
        },
    });

    const confirmReceptionForAllProductsMutation = useMutation({
        mutationFn: confirmReceptionForAllProducts,
        onSuccess: () => {
            toast.success("Le Arrivage est Réceptionné avec Succès");
            queryClient.invalidateQueries('arrivage');
            setArrivageStatus(2);
            setIsLoading(false);
        },
        onError: (error) => {
            toast.error(error.message);
            setIsLoading(false);
        },
    });

    const handleSubmit = (e, product) => {
        e.preventDefault();
        setIsLoading(true);
        const updatedProduct = formData.products.find(p => p.id === product.id);
        
        // Use the correct payload structure for updateProductArrivageStatus
        const payload = {
            arrivageId: selectedArrivage.id,
            productId: product.id,
            quantityReceived: parseInt(updatedProduct?.quantityReceived || product?.pivot?.kdQuantity)
        };
        
        console.log(payload);
        mutation.mutate(payload);
    };

    const handleConfirmAll = (e) => {
        e.preventDefault();
        setIsLoading(true);

        // Format payload for confirmReceptionForAllProducts
        const payload = {
            id: selectedArrivage.id,
            products: formData.products.map(product => ({
                id: product.id,
                quantityReceived: parseInt(product.quantityReceived || product.pivot.kdQuantity)
            }))
        };

        confirmReceptionForAllProductsMutation.mutate(payload);
    };

    if (!open) return null;

    return (
        <div
            className="fixed inset-0 z-50"
            style={{ zIndex: 9991, overflow: "visible" }}
            aria-labelledby="modal-title"
            role="dialog"
            aria-modal="true"
        >
            {/* Overlay */}
            <div
                className="fixed inset-0 bg-gray-500 bg-opacity-75"
                aria-hidden="true"
                onClick={() => setOpen(false)}
            />

            {/* Modal Content */}
            <div className="flex items-center justify-center min-h-screen p-4">
                <div
                    className="relative w-full max-w-lg mx-auto bg-white shadow-lg rounded-lg overflow-hidden"
                    onClick={(e) => e.stopPropagation()}
                >
                    {/* Header */}
                    <div className="flex justify-between items-center p-6 bg-[#b269ae] border-b border-gray-500/30 pb-4">
                        <h3 id="modal-title" className="text-lg font-medium leading-6 text-white">
                            Réceptionner Arrivage
                        </h3>
                        <button
                            type="button"
                            className="inline-flex items-center justify-center p-1.5 text-gray-400 hover:text-gray-500 hover:scale-105 duration-200"
                            onClick={() => setOpen(false)}
                        >
                            <RiCloseLine className="h-6 w-6 text-white" aria-hidden="true" />
                        </button>
                    </div>
                    <div className="p-4 border-b mx-5 flex justify-between items-center">
                        <li>ID de l'arrivage: <span className="font-semibold text-[#b269ae]">{selectedArrivage?.id}</span></li>
                        <button
                            onClick={(e) => handleConfirmAll(e)}
                            className="block rounded-md bg-yellow-300 px-3 py-2 text-center text-sm font-semibold text-white shadow-sm hover:bg-yellow-300 duration-300 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-yellow-600 disabled:bg-gray-700/40 disabled:cursor-not-allowed"
                            disabled={arrivageStatus === 2 || isLoading}
                        >
                            {confirmReceptionForAllProductsMutation.isPending ? "Loading.." : "Confirmer Tous"}
                        </button>
                    </div>
                    <form className="space-y-4 p-6">
                        {Arrivage[0]?.products.map((product) => (
                            <div key={product.id}>
                                <label className="block text-sm font-medium text-gray-700">
                                    {product.title} (ID: {product.id})
                                </label>
                                <div className="flex gap-4 items-center">
                                    <div className="flex-1">
                                        <label className="block text-xs text-gray-500 mb-1">
                                            Quantité Demandée: {product?.pivot?.kdQuantity}
                                        </label>
                                        <input
                                            type="number"
                                            defaultValue={product.pivot.received_quantity ? product.pivot.received_quantity : product.pivot.kdQuantity}
                                            max={product?.pivot?.kdQuantity}
                                            onChange={(e) => {
                                                const quantityReceived = e.target.value;
                                            
                                                setFormData((prev) => ({
                                                    ...prev,
                                                    products: prev.products.map((p) =>
                                                        p.id === product.id ? { ...p, quantityReceived } : p
                                                    )
                                                }));
                                            }}
                                            required
                                            className="mt-1 block w-full rounded-md border border-gray-300 shadow-sm focus:border-[--secondaryColor] focus:ring-[--secondaryColor] sm:text-sm h-12"
                                        />
                                    </div>
                                    <div className="mt-6 flex justify-end gap-6">
                                        {product?.pivot?.status == 1 ? (
                                            <button
                                                type="button"
                                                className="rounded-md bg-green-600/10 px-3 py-1 text-center text-sm font-semibold border border-green-600 text-green-600 shadow-sm duration-300 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 cursor-not-allowed flex items-center gap-2"
                                            >
                                                <CiCircleCheck size={20} /> Réceptionné
                                            </button>
                                        ) : (
                                            <button
                                                onClick={(e) => handleSubmit(e, product)}
                                                className="block rounded-md bg-[#b269ae] px-3 py-2 text-center text-sm font-semibold text-white shadow-sm hover:bg-yellow-300 duration-300 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-yellow-600"
                                                disabled={isLoading}
                                            >
                                                Confirmer Réception
                                            </button>
                                        )}
                                    </div>
                                </div>
                            </div>
                        ))}
                    </form>
                </div>
            </div>
        </div>
    );
};

export default ChangeArrivageStatusModal;